import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSplitView = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeMiterlimit: 10,
	strokeLinecap: "square",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M31 11H9V29H31V11Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 11V29" }),
		/* @__PURE__ */ _jsx("path", { d: "M25 16H27" }),
		/* @__PURE__ */ _jsx("path", { d: "M25 20H27" }),
		/* @__PURE__ */ _jsx("path", { d: "M25 24H27" })
	]
});
const ForwardRef = forwardRef(SvgSplitView);
export default ForwardRef;
